import React from 'react';
import { Building, Users } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { formatNumber } from '../../../utils/format/currency';

interface MarketRateProps {
  type: 'official' | 'parallel';
  rate: number;
  currency: string;
  lastUpdated?: Date;
}

export function MarketRate({ type, rate, currency, lastUpdated }: MarketRateProps) {
  const Icon = type === 'official' ? Building : Users;
  const title = type === 'official' ? 'Official Bank Rate' : 'Parallel Market Rate';
  const subtitle = type === 'official' ? 'Official Bank Rate' : 'Black Market Rate';
  const iconColor = type === 'official' ? 'text-blue-600' : 'text-purple-600';
  const bgColor = type === 'official' ? 'bg-blue-50' : 'bg-purple-50';

  return (
    <div className={`p-4 ${bgColor} rounded-lg border ${type === 'official' ? 'border-blue-100' : 'border-purple-100'}`}>
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`h-4 w-4 ${iconColor}`} />
        <span className="font-medium">{title}</span>
      </div>
      <p className="text-2xl font-bold">
        {formatNumber(rate)} {currency}
      </p>
      <div className="flex items-center justify-between mt-2">
        <p className="text-sm text-gray-600">{subtitle}</p>
        {lastUpdated && (
          <p className="text-xs text-gray-500">
            {formatDistanceToNow(lastUpdated, { addSuffix: true })}
          </p>
        )}
      </div>
    </div>
  );
}